import { useSelector } from 'react-redux';
import { RootState } from '../../layout/core/reducers/wfp-core-store.type';
import { websiteLocaleToPaymentLocale } from '../utils';

export function useGetPaymentLocale() {
    const currentLanguage = useSelector((state: RootState) => state.session.curLanguage);
    return websiteLocaleToPaymentLocale(currentLanguage);
}
